import PageLayout from "../../layouts/pagelayout/PageLayout";
import { Fragment, useEffect, useState } from "react";
import "./ContactUs.scss";
import ContactLanding from "./contactUslanding/ContactLanding";
import DemoForm from "./demoform/DemoForm";
import WOW from "wow.js";
import axios from "axios";
import { baseUrl, contactPage } from "../../utils/apiData";
import LoaderCard from "../../components/loaderCard/LoaderCard";

const ContactUs = () => {
  const [loader, setLoader] = useState(false);
  const [contactPageData, setContactPageData] = useState({});

  useEffect(() => {
    const wow = new WOW();
    wow.init();
  }, []);

  const getContactApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${contactPage}`);
      if (res?.data?.success) {       
        setContactPageData(res?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    getContactApi();
  }, []);

  return (
    <PageLayout>
      {loader ? (
        <LoaderCard />
      ) : (
        <Fragment>
          <ContactLanding title={contactPageData?.title || "-"} bgImg={contactPageData?.image}/>
          <DemoForm data={contactPageData} />
          
        </Fragment>
      )}
    </PageLayout>
  );
};

export default ContactUs;
